export default __webpack_public_path__ + "static/media/background1.eea81b23.jpg";